import {
	ITimelineData, IInteraction, IDataTrackAreaItem, IDataWidget, IProcedure,
	IMessage, IAction, IConditionVariable, IDataSourceContainer, ICondition, IActionParameter, ITimelineForm
} from '../redux/timeline-data.model';
import { bbGenerateShortId } from '../../../../shared/utils/bbGenerateShortId.util';
import { TIMELINE_DATA_INITIAL_STATE } from '../redux/timeline-data.store';

export class TimelineDataConverter {
	public static restructureConfig(config: any): void {
		if (!config) {
			return;
		} // bail out

		// restructure margin & padding
		if (config.textFormat && config.textFormat.textFormat) {
			const tf = config.textFormat.textFormat; // short-hand
			if ((tf.leftMargin !== undefined || tf.rightMargin !== undefined ||
				config.toppadding !== undefined || config.bottompadding !== undefined) && tf.margin === undefined) {
				let margin_t = !isNaN(parseFloat(config.toppadding)) ? config.toppadding : '0';
				if (!margin_t.match(/%$/)) {
					margin_t = (+(100 * parseFloat(margin_t) / 378).toFixed(4)).toString() + '%';
				} // NB + removes '0's!
				let margin_r = !isNaN(parseFloat(tf.rightMargin)) ? tf.rightMargin : '0';
				if (!margin_r.match(/%$/)) {
					margin_r = (+(100 * parseFloat(margin_r) / 672).toFixed(4)).toString() + '%';
				} // NB + removes '0's!
				let margin_b = !isNaN(parseFloat(config.bottompadding)) ? config.bottompadding : '0';
				if (!margin_b.match(/%$/)) {
					margin_b = (+(100 * parseFloat(margin_b) / 378).toFixed(4)).toString() + '%';
				} // NB + removes '0's!
				let margin_l = !isNaN(parseFloat(tf.leftMargin)) ? tf.leftMargin : '0';
				if (!margin_l.match(/%$/)) {
					margin_l = (+(100 * parseFloat(margin_l) / 672).toFixed(4)).toString() + '%';
				} // NB + removes '0's!
				tf.margin = margin_t + ';' + margin_r + ';' + margin_b + ';' + margin_l;
				delete config.toppadding;
				delete (tf.leftMargin);
				delete config.bottompadding;
				delete (tf.rightMargin);
			}
		}

		// restructure font size
		if (config.textFormat && config.textFormat.textFormat) {
			const tf = config.textFormat.textFormat; // short-hand
			if (tf.size !== undefined && tf.fontsize === undefined) {
				tf.fontsize = (+(100 * parseFloat(tf.size) / 378).toFixed(4)).toString() + '%'; // NB + removes '0's!
				delete (tf.size);
			}
		}

		// restructure background opacity
		if (config.background !== undefined && config.background_alpha === undefined) {
			config.background_alpha = (config.background === 'true') ? '100%' : '0%';
			delete (config.background);
		}
	}

	public static convertOldTimelineData(oldTimeLineData: any): ITimelineData {
		const eventHandlerNames: string[] = ['onclick', 'onclosed', 'onhide', 'onenter', 'onshow', 'onmouseover', 'onmouseout', 'ontransitionDone',
			'onclickToggleOn', 'onclickToggleOff', 'onstart', 'onstop', 'ontick', 'oncomplete', 'onfinished', 'onclickToggleOn', 'onclickToggleOff',
			'onvalidationsucceeded', 'onvalidationfailed', 'onSuccess', 'onFailure', 'onAllWidgetsValidated'];
		let newTimeLineData: ITimelineData = null;

		if (oldTimeLineData.timeevents) { // determines if old data model
			// console.log('[TimelineDataConverter] convertOldTimelineData old data model');
			newTimeLineData = {
				subtype: 'versioned',
				modelVersion: '2',
				id: oldTimeLineData.id,
				status: oldTimeLineData.status,
				parentEntityType: oldTimeLineData.parentEntityType,
				parentEntityId: oldTimeLineData.parentEntityId,
				createddate: oldTimeLineData.createddate,
				updateddate: oldTimeLineData.updateddate,
				interactions: new Array<IInteraction>(),
				groupTags: oldTimeLineData.groupTags,
				widgets: [],
				order: [], // rename to tracks?
				forms: oldTimeLineData.forms ? this.parseForms(oldTimeLineData.forms) : [{
					name: '',
					method: 'POST',
					action: '',
					email: '',
					formEmailTemplate: '',
					formEmailFrom: '',
					onSuccess: [],
					onFailure: [],
					onAllWidgetsValidated: [],
					id: '1'
				}], // use spread?
				options: oldTimeLineData.options && oldTimeLineData.options[0] ? oldTimeLineData.options[0] : (
					typeof oldTimeLineData.options === 'object' && oldTimeLineData.options ? oldTimeLineData.options : TIMELINE_DATA_INITIAL_STATE.data.options
				), // was array, now object
				messages: oldTimeLineData.messages ? this.parseMessages(oldTimeLineData.messages) : []
			};

			const tes: any[] = oldTimeLineData.timeevents;
			tes.forEach((te) => {
				let newTrack: IDataTrackAreaItem;
				let newWidget: IDataWidget;

				// Create Track within order array with in-out-points
				if (te.inpoint != null && te.outpoint != null) {
					newTrack = {
						id: String(Math.floor(Math.random() * 9898946546) + 1),
						type: 'track',
						widgetid: 'string', /* huh? */
						inoutpoints: [{
							id: String(Math.floor(Math.random() * 9898946546) + 1),
							inpoint: te.inpoint,
							outpoint: te.outpoint
						}]
					};
					if (te.widget != null && te.widget.id != null) {
						newTrack.widgetid = te.widget.id;
					}
					newTimeLineData.order.push(newTrack);
				}

				if (te.widget != null && te.widget.config != null) {
					newWidget = {
						id: '',
						status: '',
						widgetdefinitiontype: '',
						widgetdefinitionid: '',
						label: '',
						statesets: [
							{
								name: 'default',
								states: [
									{ name: 'default', config: {} },
									{ name: 'mouseover', config: {} },
									{ name: 'mousedown', config: {} },
									{ name: 'toggled', config: {} },
									{ name: 'toggledmouseover', config: {} },
									{ name: 'toggledmousedown', config: {} }]
							}
						],
						grouping: [],
						animations: []
					};

					for (const prop in te.widget) { // there is more data in widget objects from backend, filling within a loop
						if (te.widget.hasOwnProperty(prop)) {
							if (prop === 'config') {
								// nothing; will deal with later
							} else if (prop === 'app') {
								newWidget.apps = [te.widget.app]; // restructure
							} else if (!te.widget.config.hasOwnProperty(prop)) { // filter out double config values from widget root
								newWidget[prop.toString()] = te.widget[prop];
							}
						}
					}

					// add Config to default state in default stateset
					const config = newWidget.statesets[0].states[0].config;
					for (const prop in te.widget.config) {
						if (te.widget.config.hasOwnProperty(prop) && prop != null && te.widget.config[prop] != null) {
							if (prop.toString() === 'grouping') { // lift out grouping to widget level
								const grouping = te.widget.config[prop];
								if (grouping && grouping.groups) {
									newWidget.grouping = grouping.groups;
								} else if (grouping && grouping.length) {
									newWidget.grouping = grouping;
								} else {
									newWidget.grouping = [];
								}
							} else if (prop.toString() === 'widgetoverrides') {  // handle override fields
								const widgets = te.widget.config[prop].widgets;
								if (widgets && widgets.length > 0) {
									for (let i = 0; i < widgets.length; i++) {
										for (const p in widgets[i].config) {
											if (widgets[i].config.hasOwnProperty(p)) {
												if (typeof widgets[i].config[p] === 'object' && widgets[i].config[p].actions != null) {
													let procedures: IProcedure[] = [];
													// event handler, turn into procedures
													procedures = this.actionsToProcedures(widgets[i].config[p].actions);
													widgets[i].config[p.toString()] = procedures;
												}
											}
										}
										TimelineDataConverter.restructureConfig(widgets[i].config);
									}
									config[prop.toString()] = te.widget.config[prop];
								}
							} else {
								if (typeof te.widget.config[prop] === 'object' && te.widget.config[prop].actions != null) {
									let procedures: IProcedure[] = [];
									// event handler, turn into procedures
									procedures = this.actionsToProcedures(te.widget.config[prop].actions);
									config[prop.toString()] = procedures;
								} else {
									if (te.widget.config[prop] === '') {  // remove empty strings
										// config[prop.toString()] = null;
										// ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^ this is reason why widget overrides do not work for converted tmplates.
										// Turning it back on (for eventhandlers)
										if (eventHandlerNames.indexOf(prop) !== -1) {
											config[prop.toString()] = null;
										}
									} else {
										const newProp = te.widget.config[prop] as string;
										let convertedProperty: any;
										if (newProp && newProp.match) {
											const matches = newProp.match(/dataSource:\{[^}]*\}/gm); // NB dataSource must not have nested {}!
											if (matches != null && matches.length > 0) {
												convertedProperty = { datasource: JSON.parse((newProp.replace(/^dataSource:/i, '').trim())) };
											}
										}
										config[prop.toString()] = convertedProperty ? convertedProperty : te.widget.config[prop];
									}
								}
							}
						}
					}
					TimelineDataConverter.restructureConfig(config);

					// check animation data an move to animations array
					if (te.position != null) {
						newWidget.animations.push(te.position);
					}
					if (te.size != null) {
						newWidget.animations.push(te.size);
					}
					if (te.alpha != null) {
						newWidget.animations.push(te.alpha);
					}

					newTimeLineData.widgets.push(newWidget);
				}
			});
		} else { // already new data model
			// console.log('[TimelineDataConverter] convertOldTimelineData new data model');
			newTimeLineData = oldTimeLineData; // cast?
			newTimeLineData.widgets = newTimeLineData.widgets || [];

			// THIS RESTRUCTURING CODE IS NEEDED TEMPORARILY - BEGIN
			for (let i = 0, l = newTimeLineData.widgets.length; i < l; i++) {
				const widget = newTimeLineData.widgets[i];
				if (widget) {
					// restructure apps
					if (!widget.apps && widget.app) {
						widget.apps = [widget.app];
						delete widget.app;
					}

					const config = widget.statesets[0].states[0].config;
					TimelineDataConverter.restructureConfig(config);
				}
			}
			// THIS RESTRUCTURING CODE IS NEEDED TEMPORARILY - END

		}
		// console.log( '[TimelineDataConverter] convertOldTimelineData timeline data:', JSON.parse(JSON.stringify( newTimeLineData )));
		return newTimeLineData;
	}

	private static parseMessages(in_messages: any[]): IMessage[] {
		const messages: IMessage[] = new Array<IMessage>();
		for (let i = 0, l: number = in_messages.length; i < l; i++) {
			if (in_messages[i].name != null && in_messages[i].actions != null) {
				messages.push({
					name: in_messages[i].name,
					procedures: this.actionsToProcedures(in_messages[i].actions)
				});
			}
		}
		return messages;
	}

	private static parseForms(in_forms: any[]): ITimelineForm[] {
		const forms: ITimelineForm[] = new Array<ITimelineForm>();
		for (let i = 0, l: number = in_forms.length; i < l; i++) {
			if (in_forms[i] != null) {
				forms.push({
					id: in_forms[i].id,
					name: in_forms[i].name,
					method: in_forms[i].method,
					action: in_forms[i].action,
					email: in_forms[i].email,
					formEmailTemplate: in_forms[i].formEmailTemplate,
					formEmailFrom: in_forms[i].formEmailFrom,
					onSuccess: in_forms[i].onSuccess && in_forms[i].onSuccess.actions ? this.actionsToProcedures(in_forms[i].onSuccess.actions) : [],
					onFailure: in_forms[i].onFailure && in_forms[i].onFailure.actions ? this.actionsToProcedures(in_forms[i].onFailure.actions) : [],
					onAllWidgetsValidated: in_forms[i].onAllWidgetsValidated && in_forms[i].onAllWidgetsValidated.actions
						? this.actionsToProcedures(in_forms[i].onAllWidgetsValidated.actions)
						: [],
				});
			}
		}
		return forms;
	}

	private static actionsToProcedures(in_actions: any[]): IProcedure[] {
		const procedures: IProcedure[] = new Array<IProcedure>();
		for (let i = 0, l: number = in_actions.length; i < l; i++) {

			const actions: IAction[] = new Array<IAction>();

			const action: IAction = this.parseAction(in_actions[i]);
			if (action) {
				actions.push(action);
			}
			let condition: ICondition;
			if (in_actions[i].conditions) {
				condition = this.parseCondition(in_actions[i].conditions);
			} else {
				condition = {
					variables: new Array<IConditionVariable>(),
					expression: ''
				};
			}

			// action-condition pair becomes a procedure
			const procedure: IProcedure = {
				id: bbGenerateShortId(),
				condition,
				actions,
				else_actions: new Array<IAction>(),
				type: condition.variables.length ? 'conditional' : (actions.length ? 'simple' : 'empty')
			};
			procedures.push(procedure);
		}
		return procedures;
	}

	private static parseAction(actionObject: any): IAction {

		let entity = '';
		let cmd = '';
		const parameters: IActionParameter[] = new Array<IActionParameter>();

		if (actionObject) {
			const action: string = actionObject.action || '';

			// matches 'scheme:foobar', or
			//         'widget:setvalue(2594,dataSource:{"defaultValue":"","sourceValue":"blaf('foo', \"bar\")","sourceType":"JavaScript"})'
			const regExp = /^(\w*):(\w*)(.*)$/;
			const result: RegExpExecArray = regExp.exec(action.trim());
			if (result != null) {
				const dataSourceReplaceMap: any[] = [];
				const macroReplaceMap: any[] = [];

				entity = result[1].toString();
				cmd = result[2].toString();
				let args_str: string = result[3].toString();
				if (entity.match(/javascript/i)) {
					args_str = cmd + args_str; cmd = '';
				} // special case

				// handle arguments
				let args: any[];
				if (args_str.length > 0) {

					// replace macros
					const temp = args_str.match(/{{\s*[\w\.]+\s*}}/g);
					if (temp != null) {

						for (let i = 0; i < temp.length; i++) {
							const rep: string = '%macro_replace_value_' + i + '%';
							macroReplaceMap.push({ orig: temp[i], replace: rep });
							args_str = args_str.replace(temp[i], rep);
						}
					}

					// replace dataSources
					const matches = args_str.match(/dataSource:\{[^}]*\}/gm); // NB dataSource must not have nested {}!
					if (matches != null && matches.length > 0) {
						for (let i = 0; i < matches.length; i++) {
							const rep: string = '%datasource_replace_value_' + i + '%';
							dataSourceReplaceMap.push({ orig: matches[i], replace: rep });
							args_str = args_str.replace(matches[i], rep);
						}
					}

					// cleanly separate arguments
					if (!entity.match(/javascript/i)) {
						args_str = args_str.replace(/^\(|\)$/gm, ''); // strip enclosing parentheses
						args_str = args_str.replace(/\\"/gm, '%escaped_double_quote%'); // disguise escaped double quotes
						args_str = args_str.replace(/\\'/gm, '%escaped_single_quote%'); // disguise escaped single quotes
						let re_comma = /,/gm;
						if (args_str.match(re_comma)) {
							args = [];
							const re_double_quote = /"/gm;
							const index_double_quote = [];
							while (re_double_quote.exec(args_str) !== null) {
								index_double_quote.push(re_double_quote.lastIndex - 1);
							}
							index_double_quote.push(args_str.length); // trick
							let prevIndex = -1;
							re_comma = /,/gm; // reset regex object, for IE8 won't exec after match above...
							while (re_comma.exec(args_str) !== null) {
								const index_comma = re_comma.lastIndex - 1;
								let i = 0;
								while (i < index_double_quote.length) {
									if (index_comma < index_double_quote[i]) {
										if (i % 2 === 0) { // even
											args.push(args_str.substring(prevIndex + 1, index_comma));
											prevIndex = index_comma;
										}
										break;
									}
									i++;
								}
							}
							if (prevIndex < args_str.length) {
								args.push(args_str.substring(prevIndex + 1));
							} // don't forget the last part;)
						} else if (args_str !== '') {
							args = [args_str];
						}
						if (args != null) {
							for (let i = 0; i < args.length; i++) {
								args[i] = args[i]
									.replace(/^\s*"|"\s*$/gm, '')
									.replace(/%escaped_double_quote%/gm, '"')
									.replace(/%escaped_single_quote%/gm, '\'');
							}
						}
					} else { // javascript
						args = [cmd + args_str];
						cmd = '';
					}

					// restructure widget calls
					if (entity.match(/widget|group/i)) {
						if (cmd.match(/setProperty/i)) { // special case
							args[1] = 'setProperty:' + args[1];
							cmd = 'callMethod';
						} else if (!cmd.match(/callMethod/i)) {
							args.splice(1, 0, cmd);
							cmd = 'callMethod';
						}
					}
					// console.log('[] parseAction cmd: ' + cmd + ', args: ', args);

					// reverse replace datasources and macros and collect parameters
					if (args != null && args.length > 0) {
						for (let i = 0, l: number = args.length; i < l; i++) {
							let arg: string = args[i];
							for (let j = 0, ll: number = dataSourceReplaceMap.length; j < ll; j++) {
								arg = arg.replace(dataSourceReplaceMap[j].replace, dataSourceReplaceMap[j].orig);
							}
							for (let j = 0, ll: number = macroReplaceMap.length; j < ll; j++) {
								arg = arg.replace(macroReplaceMap[j].replace, macroReplaceMap[j].orig);
							}

							// collect parameters
							const name = 'p_' + i;
							let actionParameter: IActionParameter;
							if (arg.indexOf('dataSource') !== -1) {
								// create object from data source immediately
								actionParameter = {
									name,
									value: { datasource: JSON.parse((arg.replace(/^dataSource:/i, '').trim())) }
								};
							} else {
								actionParameter = {
									name,
									value: arg
								};
							}

							parameters.push(actionParameter);
						}
					}
				}
			}
		}
		// export interface IActionParameter {
		// 	name: string;
		// 	value: string | IDataSourceContainer;
		// }

		// prevent the string 'function' in cmd (navigation only for now!?)
		cmd = (entity === 'navigation' && cmd === 'function') ? '' : cmd;

		return {
			id: bbGenerateShortId(),
			entity,
			command: cmd,
			parameters
		};
	}

	private static parseCondition(conditions: any): ICondition {
		const newCondition: ICondition = {
			variables: null,
			expression: ''
		};
		const vars: IConditionVariable[] = new Array<IConditionVariable>();
		for (const key in conditions) {
			if (key !== 'expression') {
				const name: string = key;
				const conditionVariable: IConditionVariable = this.parseConditionVariable(conditions[key]);
				conditionVariable.name = name;
				vars.push(conditionVariable);
				newCondition.variables = vars;
			} else {
				newCondition.expression = conditions[key];
			}
		}
		return newCondition;
	}

	private static parseConditionVariable(conditionVariable: string): IConditionVariable {
		let newConditionVariable: IConditionVariable;
		const dataSourceReplaceMap: any[] = [];
		const macroReplaceMap: any[] = [];

		let entity = '';
		let target = '';
		let lval: string | IDataSourceContainer;
		let operator = '';
		let rval: string | IDataSourceContainer;
		let lval_tmp: string;
		let rval_tmp: string;

		// replace macros
		const temp = conditionVariable.match(/{{\s*[\w\.]+\s*}}/g);
		if (temp != null) {
			for (let i = 0; i < temp.length; i++) {
				const rep: string = '%macro_replace_value_' + i + '%';
				macroReplaceMap.push({ orig: temp[i], replace: rep });
				conditionVariable = conditionVariable.replace(temp[i], rep);
			}
		}

		// replace dataSources
		const matches = conditionVariable.match(/dataSource:\{[^}]*\}/gm); // NB dataSource must not have nested {}!
		if (matches != null && matches.length > 0) {
			for (let i = 0; i < matches.length; i++) {
				const rep: string = '%datasource_replace_value_' + i + '%';
				dataSourceReplaceMap.push({ orig: matches[i], replace: rep });
				conditionVariable = conditionVariable.replace(matches[i], rep);
			}
		}

		// get all seperated values
		const regExp = /^(\w*):(.*)$/; // matches 'scheme:blafblaf'
		const result = regExp.exec(conditionVariable.trim());
		if (result && result.length > 2) {
			const scheme = result[1].toString();
			const evaluate_str: string = result[2];

			const regExp2 = /(.*)\((.*)\)/; // matches 'function()' or 'function(args)'
			const result2 = regExp2.exec(evaluate_str);

			if (result2 != null) {
				// let cmd = (result2[1]).trim(); // "evaluate"
				const args = String(result2[2]).split(',');
				args[1] = String(args[1]).replace(':', '=='); // compat.

				const match = (args[1]).match(/(.*[^><!=~])(==|!=|~=|<|<=|>|>=)([^><!=~].*)/); // matches foo==bar, foo!=bar, etc.

				entity = scheme;
				if (args[0] === 'null') {
					target = null;	// target becomes a real null now
				} else {
					target = args[0];
				}
				lval_tmp = match[1];
				operator = match[2];
				rval_tmp = match[3];
			}

			// reverse replace datasources and macros and collect parameters
			for (let j = 0, ll: number = dataSourceReplaceMap.length; j < ll; j++) {
				lval_tmp = lval_tmp.replace(dataSourceReplaceMap[j].replace, dataSourceReplaceMap[j].orig);
				rval_tmp = rval_tmp.replace(dataSourceReplaceMap[j].replace, dataSourceReplaceMap[j].orig);
			}
			for (let j = 0, ll: number = macroReplaceMap.length; j < ll; j++) {
				lval_tmp = lval_tmp.replace(macroReplaceMap[j].replace, macroReplaceMap[j].orig);
				rval_tmp = rval_tmp.replace(macroReplaceMap[j].replace, macroReplaceMap[j].orig);

				if (lval_tmp.indexOf('dataSource') !== -1) {
					lval = { datasource: JSON.parse((lval_tmp.replace(/^dataSource:/i, '')).trim()) };
				}

				if (rval_tmp.indexOf('dataSource') !== -1) {
					rval = { datasource: JSON.parse((rval_tmp.replace(/^dataSource:/i, '')).trim()) };
				}
			}
			if (!lval) {
				lval = lval_tmp;
			}
			if (!rval) {
				rval = rval_tmp;
			}

			newConditionVariable = {
				name: '',
				entityType: entity,
				entityId: target,
				rule: {
					lvalue: lval,
					operator,
					rvalue: rval
				}
			};

		}
		return newConditionVariable;
	}
}
